import { Box, Flex, Text } from "@radix-ui/themes";
import { useAppSelector } from "@/app/appStore";
import { selectSelectedClosestGondolaDistItem } from "@/entities/gondola-change-groups";
import { SKU_SECTION_COLORS } from "../lib/const";

const LegendBox = () => {
  const selectedClosestGondolaDistItem = useAppSelector(
    selectSelectedClosestGondolaDistItem
  );

  return (
    <Box className="absolute bottom-8 right-0 bg-black bg-opacity-80 rounded-md p-3 z-30">
      <Flex gap="2">
        {selectedClosestGondolaDistItem && (
          <>
            <Flex align="center" gap="2">
              <Box
                className="w-6 h-6 border-2"
                style={{
                  backgroundColor: `${SKU_SECTION_COLORS.CLOSEST_GONDOLA_DIST}40`,
                  borderColor: SKU_SECTION_COLORS.CLOSEST_GONDOLA_DIST,
                }}
              />
              <Text className="text-white" size="2">
                Closest Gondola Dist
              </Text>
            </Flex>
            <Flex align="center" gap="2">
              <Box
                className="w-6 h-6 border-2"
                style={{
                  backgroundColor: `blue`,
                  borderColor: "#fff",
                }}
              />
              <Text className="text-white" size="2">
                Left Hand
              </Text>
            </Flex>
            <Flex align="center" gap="2">
              <Box
                className="w-6 h-6 border-2"
                style={{
                  backgroundColor: `red`,
                  borderColor: "#fff",
                }}
              />
              <Text className="text-white" size="2">
                Right Hand
              </Text>
            </Flex>
          </>
        )}
        <Flex align="center" gap="2">
          <Box
            className="w-6 h-6 border-2"
            style={{
              backgroundColor: `${SKU_SECTION_COLORS.OCCLUSION}40`,
              borderColor: SKU_SECTION_COLORS.OCCLUSION,
            }}
          />
          <Text className="text-white" size="2">
            Occlusion
          </Text>
        </Flex>
        <Flex align="center" gap="2">
          <Box
            className="w-6 h-6 border-2"
            style={{
              backgroundColor: `${SKU_SECTION_COLORS.DETECTION}40`,
              borderColor: SKU_SECTION_COLORS.DETECTION,
            }}
          />
          <Text className="text-white" size="2">
            Detection
          </Text>
        </Flex>
        <Flex align="center" gap="2">
          <Box
            className="w-6 h-6 border-2"
            style={{
              backgroundColor: `${SKU_SECTION_COLORS.TRIANGULATION}40`,
              borderColor: SKU_SECTION_COLORS.TRIANGULATION,
            }}
          />
          <Text className="text-white" size="2">
            Triangulation
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
};

export default LegendBox;
